import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import BackHomeButton from '../components/BackHomeButton';
import AutoScrollPreview from "../components/AutoScrollPreview";
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebase';

function UserDownloadPage() {
  const [downloads, setDownloads] = useState([]);
  const navigate = useNavigate();
  const [filteredDownloads, setFilteredDownloads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [documentTypeFilter, setDocumentTypeFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const downloadsPerPage = 5;
  

  useEffect(() => {
    const fetchDownloads = async () => {
      //const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        //const db = getFirestore();
        const downloadsRef = collection(db, 'Downloads_And_Generations');
        const downloadsQuery = query(downloadsRef, where('userId', '==', user.uid));
        const querySnapshot = await getDocs(downloadsQuery);

        const allDownloads = querySnapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .sort((a, b) => (b.timestamp?.seconds || 0) - (a.timestamp?.seconds || 0));

        // Deduplicate — keep only latest per fileUrl
        const uniqueDownloadsMap = new Map();

        for (const download of allDownloads) {
          if (!uniqueDownloadsMap.has(download.fileUrl)) {
            uniqueDownloadsMap.set(download.fileUrl, download);
          }
        }

        const userDownloads = Array.from(uniqueDownloadsMap.values());

        setDownloads(userDownloads);
        setFilteredDownloads(userDownloads);
      }

      setLoading(false);
    };

    fetchDownloads();
  }, []);

  useEffect(() => {
    let filtered = downloads;

    if (documentTypeFilter !== 'All') {
      filtered = filtered.filter(d => d.type.includes(documentTypeFilter));
    }

    if (searchTerm.trim()) {
      filtered = filtered.filter(d =>
        (d.fileName|| '').toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

      // ✅ Sort descending by uploadTime
      filtered.sort((a, b) => (b.uploadTime?.seconds || 0) - (a.uploadTime?.seconds || 0));

    setFilteredDownloads(filtered);
    setCurrentPage(1);
  }, [documentTypeFilter, searchTerm, downloads]);

  const indexOfLast = currentPage * downloadsPerPage;

  if (loading) return <div>Loading...</div>;

return (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

    <BackHomeButton className="mt-6" />

    <h2 className="text-3xl font-bold mb-8 text-gray-800">
      Your Downloaded Files. 
    </h2>
    <p>Total Files : {downloads.length} Shown Newest first to Oldest</p>
    <br></br>

    {/* Filter + Search */}
    <div className="flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between mb-8">
      <div className="flex items-center gap-3">
        <label className="font-semibold text-gray-700">
          Filter by Type:
        </label>
        <select
          value={documentTypeFilter}
          onChange={(e) => setDocumentTypeFilter(e.target.value)}
          className="px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="All">All</option>
          <option value="Worksheet">Worksheet</option>
          <option value="Quiz">Quiz</option>
          <option value="Assessment">School Assessment</option>
        </select>
      </div>

      <input
        type="text"
        placeholder="Search by File Name,Subject,Lesson ,Topic etc. etc."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full sm:w-172 :w-100 px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>

    <div>
      <p className="text-gray-500">{filteredDownloads.length} Files found.</p>
    </div>

    <br></br>

    {/* Downloads Grid */}
    {filteredDownloads.length === 0 ? (
      <p className="text-gray-500">No downloads found.</p>
    ) : (
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        {filteredDownloads.map((download) => {
          const lastDownloaded = download.timestamp?.seconds
            ? new Date(download.timestamp.seconds * 1000).toLocaleString()
            : 'Unknown date';

          return (
            <div
              key={download.id}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 overflow-hidden border"
            >
              {/* File Preview */}
              
              <div className="bg-gray-100 flex items-center justify-center h-[400px] lg:h-[450px]">
                {download.fileUrl?.toLowerCase().includes('.pdf') ? (
                  /Android/i.test(navigator.userAgent) ? (
                    <iframe
                      src={`https://docs.google.com/gview?url=${encodeURIComponent(download.fileUrl)}&embedded=true`}
                      title="preview"
                      loading="lazy"
                      className="w-full h-full"
                    />
                  ) : (
                    <iframe
                      src={`${download.fileUrl}#toolbar=0&navpanes=0&scrollbar=1`}
                      title="preview"
                      loading="lazy"
                      className="w-full h-full"
                    />
                  )
                ) : (
                  <img
                    src={download.fileUrl}
                    alt="preview"
                    loading="lazy"
                    className="object-cover w-full h-full"
                  />
                )}
              </div>
              

              {/* Details */}
              <div className="p-4">
                
                <h3
                  className="pt-2 font-semibold text-gray-800 text-sm truncate"
                  title={download.fileName} // ✅ shows full name on hover
                >
                  {download.fileName}
                </h3>
{/*
                {download.subject && (
                  <p className="text-xs text-gray-500 mt-1">
                    School: {download.school}
                  </p>
                )}
*/}
                {download.subject && (
                  <p className="text-xs text-gray-500 mt-1">
                    Standard: {download.standard}
                  </p>
                )}

                {download.subject && (
                  <p className="text-xs text-gray-500 mt-1">
                    Subject: {download.subject}
                  </p>
                )}

                {download.type && (
                  <p className="text-xs text-blue-600 font-medium mt-1">
                    File Type: {download.type}
                  </p>
                )}

                <p className="text-xs text-gray-400 mt-1">
                  Last Downloaded: {lastDownloaded}
                </p>



                <div className="mt-4 flex gap-3">
                  <a
                    href={download.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 text-center text-xs bg-green-500 hover:bg-green-600 text-white py-2 rounded-lg transition font-medium shadow-sm"
                  >
                    Download Again
                  </a>

                  <button
                    onClick={() =>
                      navigate("/Email_Worksheet", { state: { fileUrl: download.fileUrl } })
                    }
                    className="flex-1 text-xs bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-lg transition font-medium shadow-sm"
                  >
                    Share
                  </button>
                </div>

              </div>
            </div>
          );
        })}
      </div>
    )}

    <footer className="mt-16 py-6 bg-gray-900 text-white text-center rounded-xl">
      <p className="text-sm">© 2026 Eascode All Rights Reserved.</p>
    </footer>
  </div>
);
}



export default UserDownloadPage;
